var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.jobId)?_c('div',{staticClass:"STATUS-PILL d-iflex jc-center ai-center text-md text-bold",class:{
      'bg-gray40': _vm.workOrder.isUnfinished,
      'bg-depot': _vm.workOrder.isActive,
      'bg-green': _vm.workOrder.isCompleted,
    }},[_vm._v("\n  "+_vm._s(_vm.workOrder.statusName)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }